"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _replaceLinks = require("./replaceLinks");
Object.keys(_replaceLinks).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _replaceLinks[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _replaceLinks[key];
        }
    });
});
